var timer = null;
var globalApp_timerSyncKey = null;

function ResetMenuTimer(alertText) {
	ManualReset(alertText);
}

function ManualReset(alertText) {
	if (timer != null)
		timer.Reset();
	RefreshAuthentication(alertText);
}

function InitTimer(sessionWarning, sessionExpired, timerSyncKey, resetKey) {
	if (timer == null)
		timer = new Timer(sessionWarning, sessionExpired);

	if (timer != null) {
		if (timerSyncKey) {
			globalApp_timerSyncKey = timerSyncKey
			if (resetKey)
				localStorage.removeItem(timerSyncKey);
			else {
				//new app might be opened with timer less than current - we need to check that and set correct timer
				var savVal = GetSavedTimer();
				if (savVal && savVal.Ovt > sessionExpired)
					timer = new Timer(savVal.Wat, savVal.Ovt);
			}
		}

		clearInterval(timer.timerId);
		timer.timerId = setInterval(function () { if (timer) timer.CountDown(); }, 1000);
	}
	ManualReset();
}

function Timer(warningTimeOut, overallTimeOut) {
	//properties
	this.timerId = null;
	this.nMins = 0;
	this.nSecs = 0;
	this.isTimedOut = 0;
	this.iOverallTimeOut = overallTimeOut;
	this.iWarningTimeOut = warningTimeOut;
	this.Targets = new Array();
	this.timeleft = 0;
	this.TimeOutWarningDisplayed = false;
	this.PreventTimeOutWarningCancelCallback = false;

	//methods
	this.Reset = TimerReset;
	this.CountDown = TimerCountDown;
	this.TimeOutWarning = TimerTimeOutWarning;
	this.Shutdown = TimerShutdown;
	this.TimeOutWarningMsg = CreateTimeOutWarningMsg;
	this.TimeOutWarningTitle = CreateTimeOutWarningTitle;
	this.NewTimeOutWarning = UpdateTimeOutWarning;

	this.RegisterTarget = function RT(pFn) { this.Targets.push(pFn); }
	this.UnregisterTarget = function UT(pFn) {
		for (var n = 0; n < this.Targets.length; n++) {
			if (this.Targets[n] == pFn) {
				this.Targets.splice(n, 1);
				break;
			}
		}
	}
}

// Resets the timer
function TimerReset() {
	this.nMins = this.iOverallTimeOut - 1;
	this.nSecs = 60;
	localStorage.setItem(globalApp_timerSyncKey, JSON.stringify({ origTm: Date.now() }));
	TimerOutput(this.iOverallTimeOut, 0, false);
}

// Counts down the timer
function TimerCountDown() {
	if (this.iOverallTimeOut - this.iWarningTimeOut > this.nMins) {
		this.TimeOutWarning();
	}
	else if (this.TimeOutWarningDisplayed) {
		//warning should not be displayed - close it
		this.TimeOutWarningDisplayed = false;
		this.PreventTimeOutWarningCancelCallback = true;//we don't want to logout because of popup closing
		$('#TimeOutWarningPopupWindow').data('kendoWindow').close();
	}
	var origTm = JSON.parse(localStorage.getItem(globalApp_timerSyncKey)).origTm;
	if (origTm != null ) {
		var actualTimePassed = (this.iOverallTimeOut * 60) - parseInt((Math.abs(origTm - Date.now()) / 1000)); //compare in seconds
		if (actualTimePassed < 0)
			this.Shutdown();
		this.nSecs = parseInt(actualTimePassed % 60);
		this.nMins = parseInt(actualTimePassed / 60);
	}

	if (this.nSecs == 0) {
		this.nSecs = 59;
		this.nMins--;
		this.NewTimeOutWarning(this.iWarningTimeOut - this.nMin);
	}
	else
		this.nSecs--;

	TimerOutput(this.nMins, this.nSecs, true);

	if (this.nSecs == 0) //we check auth time remaining once per minute
	{
		if (this.timeLeft <= 0 || this.nMins <= 0) {
			this.isTimedOut = 1;
			this.Shutdown();
		}
	}

	var dt = new Date();
	for (var n = 0; n < this.Targets.length; n++) {
		if (this.Targets[n] != null)
			try {
				this.Targets[n].call(this, dt);
			} catch (errorMsg) { }
	}
}

function GetSavedTimer() {
	if (globalApp_timerSyncKey) {
		var savVal = localStorage.getItem(globalApp_timerSyncKey);
		if (savVal) {
			savVal = JSON.parse(savVal);
			if (savVal.hasOwnProperty('TotSc') && savVal.hasOwnProperty('Ts') && savVal.hasOwnProperty('Ovt') && savVal.hasOwnProperty('Wat'))
				return savVal;
		}
	}
	return null;
}

// Displays time remaining in the menu bar
function TimerOutput(minutes, seconds, canKeepSession) {
	var strSeconds = seconds;
	var strMinutes = minutes;

	//check if timer sync is needed (every 10 sec with 5 sec delay)
	var timerNow = (minutes * 60) + seconds;
	if (timer && (seconds % 10) == 5) {
		var saveCurrVals = true;
		//console.log((new Date()).toLocaleTimeString() + " --- get value for: " + globalApp_timerSyncKey);
		var savVal = GetSavedTimer();
		var currTs = Date.now();
		if (savVal) {
			//console.log("===> TotSc: " + savVal.TotSc);
			if (currTs > savVal.Ts) {
				var passSec = parseInt((currTs - savVal.Ts) / 1000) + 1;//seconds since last sync - add 1 sec offset
				var timerSaved = savVal.TotSc - passSec;//adjust timer for passed time
				var diff = timerSaved - timerNow;
				//console.log("===> DIFF: " + diff);
				if (diff > 1 && document.visibilityState == "visible") {
					//if saved timer is bigger than current timer, we need to set current timer to saved timer
					minutes = parseInt(timerSaved / 60);
					seconds = (timerSaved % 60);
					timer.nMins = minutes;
					timer.nSecs = seconds;
					timer.iOverallTimeOut = savVal.Ovt;
					timer.iWarningTimeOut = savVal.Wat;
					saveCurrVals = false;//no need to save again
					//console.log((new Date()).toLocaleTimeString() + " - change timer to: " + timer.nMins + ":" + timer.nSecs);
				}
				else if (Math.abs(diff) < 2)
					saveCurrVals = false;//no need to sync if difference is less than 2 seconds
			}
		}
		if (saveCurrVals && document.visibilityState == "visible") {
			var oTm = Date.now();
			if (savVal)
				oTm = savVal.origTm;//preserving original start time, unless timer reset
			localStorage.setItem(globalApp_timerSyncKey, JSON.stringify({ origTm: oTm, TotSc: timerNow, Ts: currTs, Ovt: timer.iOverallTimeOut, Wat: timer.iWarningTimeOut }));
			//console.log((new Date()).toLocaleTimeString() + " - save new timer: " + minutes + ":" + seconds);
		}
	}

	var keepSessionAlive = ((timerNow % 300) == 15) && canKeepSession;//call every 5 min with 15 sec delay
	//Keep session alive as long as timer is running - otherwise the session would timeout
	if (keepSessionAlive)
		KeepSessionAlive();

	if (seconds < 10) strSeconds = "0" + seconds;
	if (minutes < 10) strMinutes = "0" + minutes;

	$("#timeLeft").text(strMinutes + ":" + strSeconds);
}


// Popups the time out warning window
function TimerTimeOutWarning() {
	if (this.iWarningTimeOut == 0)
		return;
	if (!this.TimeOutWarningDisplayed) {
		this.TimeOutWarningDisplayed = true;
		//PrepareExistingPopUp(true);
		var title = this.TimeOutWarningTitle();
		var msg = this.TimeOutWarningMsg();
		showConfirmationEx(msg, TimeOutWarningConfirmCallback, TimeOutWarningCancelCallback, title, false, "TimeOutWarningPopupWindow");
	}
}

function UpdateTimeOutWarning() {
	if (this.iWarningTimeOut == 0)
		return;
	if (this.TimeOutWarningDisplayed) {
		var title = this.TimeOutWarningTitle();
		var msg = this.TimeOutWarningMsg();
		updatePopupMessageWindow(msg, title, "TimeOutWarningPopupWindow");
	}
}

function CreateTimeOutWarningMsg() {
	var minutesLeft = this.nMins + 1;
	if (minutesLeft == 1)
		return $("#TimeOutWarningMsg1").val();
	else {
		var msg = $("#TimeOutWarningMsg").val();
		return msg.replace("{0}", minutesLeft);
	}
}

function CreateTimeOutWarningTitle() {
	var minutesInactive = this.iOverallTimeOut - this.nMins - 1;
	if (minutesInactive == 1)
		return $("#TimeOutWarningTitle1").val();
	else {
		var msg = $("#TimeOutWarningTitle").val();
		return msg.replace("{0}", minutesInactive);
	}
}

function TimeOutWarningConfirmCallback() {
	if (timer != null)
		timer.TimeOutWarningDisplayed = false;
	//PrepareExistingPopUp(false);
	ResetMenuTimer('TimeOutWarningConfirmCallback');
}

function TimeOutWarningCancelCallback() {
	if (timer != null) {
		timer.TimeOutWarningDisplayed = false;
		//PrepareExistingPopUp(false);
		timer.isTimedOut = 0;
		if (timer.PreventTimeOutWarningCancelCallback) {
			timer.PreventTimeOutWarningCancelCallback = false;
			return;
		}
		timer.Shutdown();
	}
}

// Shutdown the timer and logout
function TimerShutdown() {
	clearInterval(this.timerId);
	LogOutSystem(this.isTimedOut);
}

function LogOutSystem(isTimedOut) {
	isSystemLoggedOut = true;
	if (isTimedOut == null)
		isTimedOut = 0;

	if (isTimedOut == 1)
		Logout($("#LogoutReasonSessionTimeout").val());
	else
		Logout($("#LogoutReasonUserLogout").val());
}

//executed only on manual reset
function RefreshAuthentication(alertText, failedAttempt) {
	if (timer == null && failedAttempt == null || failedAttempt == undefined || isNaN(failedAttempt))
		failedAttempt = 0;
	var actionUrl = $("#RefreshAuthenticationURL").val();
	var postData = {
		sessExp: timer.iOverallTimeOut
	};
	var request = $.ajax({
		url: actionUrl,
		method: "POST",
		contentType: "application/json",
		data: JSON.stringify(postData),
		//success: function (result) {
		//console.log(">>> RefreshAuthentication: success: result=" + result.success + "; ATTEMPT=" + failedAttempt);
		//check result returned by controller - don't logout because you might be in log-in process
		//if (!result.success)
		//    timer.Shutdown();
		//},
		error: function (result) {
			console.log(">>> RefreshAuthentication: ERROR; ATTEMPT=" + failedAttempt);
			//showAlert(alertText + $("#AuthenticationRefreshError").val(), 'Error');
			if (failedAttempt < 3)//retry up to 3 times with 5 seconds delay
				setTimeout(RefreshAuthentication, 5000, alertText, failedAttempt + 1);
			else if (timer != null && timer.Shutdown != null && typeof (timer.Shutdown) == "function")
				timer.Shutdown();
		}
	});
}

// in case there is an open popupwinodw, temporarily change its id and message class to not conflict with the TimeOut confirmation
// not needed anymore - we'll use unique popup window ID
//function PrepareExistingPopUp(disable)
//{
//	if (disable) {
//		$("#popupWindow").attr("id", "popupWindow_tempDis");
//		$('#popupWindow_wnd_title').attr("id", "popupWindow_wnd_title_tempDis");
//		$('.popupMessage').removeClass("popupMessage").addClass("popupMessage_tempDis");
//	}
//	else{
//		$("#popupWindow_tempDis").attr("id", "popupWindow");
//		$('#popupWindow_wnd_title_tempDis').attr("id", "popupWindow_wnd_title");
//		$('.popupMessage_tempDis').removeClass("popupMessage_tempDis").addClass("popupMessage");
//	}
//}

// ------------------------------------
// Used to keep track of Sign timeout
// ------------------------------------
function ResetTimeout(timeoutInterval) {
	if (sessionStorage.reSignTimeOutId != undefined && sessionStorage.reSignTimeOutId != "undefined" && sessionStorage.reSignTimeOutId != "null")
		window.clearTimeout(sessionStorage.reSignTimeOutId);
	sessionStorage.reSignTimeOutId = window.setTimeout(SignCRFTimeOut, timeoutInterval);
}

function SignCRFTimeOut() {
	sessionStorage.reSignTimeOutId = null;
}

function HasSignCRFTimedOut() {
	return (sessionStorage.reSignTimeOutId == undefined || sessionStorage.reSignTimeOutId == "undefined" || sessionStorage.reSignTimeOutId == "null") ? 1 : 0;
}

function KeepSessionAlive() {
	var actionUrl = $("#KeepSessionAliveURL").val();
	var request = $.ajax({
		url: actionUrl,
		method: "POST",
		//success: function (result) {
		//    //console.log(">>> KeepSessionAlive: success;");
		//},
		//error: function (result) {
		//    console.log(">>> KeepSessionAlive: FAILED;");
		//}
	});
}
